import { render, staticRenderFns } from "./devise_links_wrapper.vue?vue&type=template&id=01fda0ce&"
import script from "./devise_links_wrapper.vue?vue&type=script&lang=js&"
export * from "./devise_links_wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports